/**
 * Marker Icon
 */
const MarkerIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{ display: 'block' }}
      xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#DA291C" />
      <path
        d="M12.0003 18.3625C12.0003 18.3625 17.3337 14.8769 17.3337 10.8473C17.3337 7.9739 14.9458 5.64453 12.0003 5.64453C9.05481 5.64453 6.66699 7.9739 6.66699 10.8473C6.66699 14.8769 12.0003 18.3625 12.0003 18.3625Z"
        fill="#F8F8F9"
      />
      <path
        d="M12 12.957C13.1046 12.957 14 12.0616 14 10.957C14 9.85247 13.1046 8.95703 12 8.95703C10.8954 8.95703 10 9.85247 10 10.957C10 12.0616 10.8954 12.957 12 12.957Z"
        fill="#DA291C"
      />
    </svg>
  )
}

export default MarkerIcon
